<template>
  <empty-alert :icon="'exclamation-circle'" :color="'teal accent-4'">
    <div slot="content">
      <p>
        <strong>Faça sua primeira avaliação física</strong>
        <br>
        Antes de fazer a sua avaliação,
        <a href="#" class="link-info">
          saiba como tirar a suas fotos e suas medidas.
        </a>
      </p>
    </div>
    <div slot="actions">
      <v-btn round depressed large color="success" dark
        v-modal-trigger="'showNewEvaluation'">
        Fazer avaliação inicial
      </v-btn>
    </div>
  </empty-alert>
</template>

<script>
import EmptyAlert from '@/modules/EmptyAlert'

export default {
  props: ['user'],
  components: {
    'empty-alert': EmptyAlert
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/evaluations/UserFirstEvaluationNotify.vue